import { styled } from '@mui/material'

import Container from 'components/Common/Container'

import { BREAK_POINTS } from 'styles/breakpoints'
import { colors, FONT_WEIGHT } from 'styles/theme'

export const StyledItem = styled(Container)({
  maxHeight: 145,
  color: colors.placeholderGray,
  borderRadius: 0,
  padding: 0,
  '& > div:nth-of-type(2)': {
    margin: 0,
  },
  ul: {
    paddingLeft: '35px',
    fontSize: 14,
    fontWeight: FONT_WEIGHT.MEDIUM,
    li: {
      '&::marker': {
        fontSize: 16,
        color: colors.blue,
      },
      span: {
        color: colors.black,
      },
    },
  },
  [`@media only screen and (max-width: ${BREAK_POINTS.MLG}px)`]: {
    width: '32%',
  },
})

export const StyledElement = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: 14,
  minHeight: 48,
  width: '100%',
  fontWeight: FONT_WEIGHT.MEDIUM,
  padding: '0px 8px',
  svg: {
    color: colors.blue,
    height: 20,
    width: 20,
    marginRight: '0.5rem',
  },
})
